import React from "react";
import { formatDate } from "../utils/formatDate";
import AuditTrailPage from "../components/AuditTrailPage";
import GiapLaiSeal from "../components/GiapLaiSeal";

function CollaboratorContractPreview({ data, company, signatoryConfig }) {
  const startDateStr = formatDate(data.startDate);
  const endDateStr = formatDate(data.endDate);
  const dobStr = formatDate(data.dob);
  const idDateStr = formatDate(data.idDate);

  // Con dấu mộc đỏ thật của công ty
  const sealImg =
    data?.seal_image ||
    data?.sealImage ||
    signatoryConfig?.sealImage ||
    company?.stampImage ||
    null;

  // Hợp đồng đã ký duyệt và đóng dấu mộc đỏ
  const isManagerStamped = Boolean(
    (data?.stamp_applied || data?.stampApplied || data?.seal_image || data?.sealImage || data?.manager_signature || data?.managerSignature) &&
    sealImg
  );

  return (
    <div
      className="contract-preview-container"
      style={{
        fontFamily: "'Times New Roman', Times, serif",
        fontSize: "13.5px",
        lineHeight: 1.55,
        color: "#111",
        padding: "36px 45px",
        background: "#fff",
      }}
    >
      {/* 1. KHỐI VĂN BẢN HỢP ĐỒNG CỘNG TÁC VIÊN */}
      <div id="contract-main-doc" className="contract-main-doc" style={{ background: "#fff" }}>
        
        {/* TRANG 1: Quốc hiệu, Bên A, Bên B, Điều 1, Điều 2 (KHÔNG có dấu giáp lai) */}
        <div className="contract-page-section" style={{ position: "relative" }}>
          {/* Quốc hiệu tiêu ngữ */}
          <div style={{ textAlign: "center", marginBottom: 18 }}>
            <div style={{ fontWeight: "bold", fontSize: 13, textTransform: "uppercase" }}>
              CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
            </div>
            <div style={{ fontWeight: "bold", fontSize: 13 }}>Độc lập - Tự do - Hạnh phúc</div>
            <div style={{ borderTop: "1px solid #111", width: 160, margin: "4px auto 0 auto" }} />
          </div>

          {/* Tên hợp đồng */}
          <div style={{ textAlign: "center", margin: "18px 0" }}>
            <div style={{ fontSize: 17, fontWeight: "bold", textTransform: "uppercase" }}>
              HỢP ĐỒNG DỊCH VỤ CỘNG TÁC VIÊN
            </div>
            <div style={{ fontStyle: "italic", marginTop: 4, fontSize: 13 }}>
              Số: <b>{data.code || "…./……./CIS-HĐCTV"}</b>
            </div>
          </div>

          <p style={{ fontStyle: "italic", margin: "6px 0", textAlign: "justify" }}>
            Căn cứ nhu cầu và khả năng thực tế của các bên trong hợp đồng;
          </p>

          <p style={{ margin: "8px 0", textAlign: "justify" }}>
            Hôm nay, ngày {startDateStr !== "—" && startDateStr !== "___/___/______" ? startDateStr : "….. tháng …. năm ……."} tại Công ty Cổ phần Thương Mại Dịch vụ CIS, chúng tôi gồm:
          </p>

          {/* Bên A */}
          <div style={{ marginBottom: 12, textAlign: "justify" }}>
            <div style={{ fontWeight: "bold" }}>BÊN A (Công ty): CÔNG TY CỔ PHẦN THƯƠNG MẠI DỊCH VỤ CIS</div>
            <div>Bà: <b>{company?.representative || "Phạm Thị Thu Lan"}</b></div>
            <div>Số CCCD/Hộ chiếu: <b>{company?.repIdNumber || "034189014297"}</b> cấp ngày <b>{company?.repIdDate || "09/08/2021"}</b></div>
            <div>Chức vụ: <b>{company?.repTitle || "Giám đốc."}</b></div>
            <div>Đại diện cho: <b>{company?.companyName || "Công ty Cổ phần Thương mại dịch vụ CIS"}</b></div>
            <div>Địa chỉ trụ sở chính: {company?.companyAddress || "Tầng 6, số 96 Nguyễn Đình Hoàn, Phường Nghĩa Đô, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam."}</div>
            <div>Giấy chứng nhận ĐKKD: <b>{company?.certificate || "0110948453"}</b> Ngày cấp: <b>{company?.dateIssued || "04/02/2025"}</b></div>
            <div>Nơi cấp: {company?.issuingAuthority || "Phòng ĐKKD Sở Kế hoạch và Đầu tư Thành phố Hà Nội"}</div>
            <div>Số điện thoại: {company?.phone || "0976567778"}</div>
          </div>

          {/* Bên B */}
          <div style={{ marginBottom: 14, textAlign: "justify" }}>
            <div style={{ fontWeight: "bold" }}>BÊN B (Cộng tác viên):</div>
            <div>Ông/Bà: <b>{data.employeeName || "___________________________"}</b> &nbsp;&nbsp;&nbsp;&nbsp; Ngày tháng năm sinh: <b>{dobStr && dobStr !== "—" && dobStr !== "___/___/______" ? dobStr : "___________"}</b></div>
            <div>Mã số thuế: <b>{data.taxCode || "___________"}</b></div>
            <div>Địa chỉ thường trú: {data.address || "___________________________________________"}</div>
            <div>Địa chỉ liên lạc hiện tại: {data.address || "___________________________________________"}</div>
            <div>
              CCCD số: <b>{data.idNumber || "___________"}</b> &nbsp;&nbsp;&nbsp;&nbsp;
              Cấp ngày: <b>{idDateStr && idDateStr !== "—" && idDateStr !== "___/___/______" ? idDateStr : "…………………"}</b> tại: <b>{data.idPlace || "Cục cảnh sát QLHC về TTXH"}</b>
            </div>
            <div>Tài khoản: <b>{data.bankAccount ? `${data.bankAccount} ${data.bankName ? `(${data.bankName})` : ''}` : "___________________________"}</b></div>
          </div>

          <p style={{ margin: "8px 0", textAlign: "justify" }}>
            Hai bên thỏa thuận ký kết hợp đồng dịch vụ Cộng tác viên và cam kết làm đúng những quy định sau:
          </p>

          {/* Điều 1 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>Điều 1. Nội dung thỏa thuận</p>
          <p style={{ margin: "4px 0", textAlign: "justify" }}>
            Bằng phương tiện của mình và cách thức, thời gian tự thu xếp phù hợp, trong phạm vi địa bàn nhất định, Bên B trực tiếp hỗ trợ cán bộ nhân viên khai thác của bên A thực hiện một hoặc toàn bộ công việc sau:
          </p>
          <ol style={{ paddingLeft: 22, margin: "6px 0", textAlign: "justify" }}>
            <li style={{ marginBottom: 4 }}>Tuyên truyền uy tín, thương hiệu bảo hiểm với khách hàng thông qua các hình thức mà pháp luật cho phép. Tìm hiểu, tìm kiếm nhu cầu mua bảo hiểm của khách hàng và cung cấp thông tin kịp thời cho cán bộ nhân viên của bên A để cấp bảo hiểm cho khách hàng khi có phát sinh.</li>
            <li style={{ marginBottom: 4 }}>Hỗ trợ cán bộ nhân viên khai thác của bên A trong công tác chuẩn bị hồ sơ, tài liệu phù hợp để bên A làm việc với khách hàng.</li>
            <li style={{ marginBottom: 4 }}>Nhập liệu, in ấn tài liệu, liên quan đến hồ sơ khách hàng, sắp xếp, chuẩn bị hồ sơ tài liệu, công việc văn phòng khác khi được cán bộ nhân viên khai thác của bên A yêu cầu.</li>
            <li style={{ marginBottom: 4 }}>Hỗ trợ cán bộ nhân viên khai thác của bên A phát tờ rơi quảng cáo tại các địa điểm xác định, mang tài liệu đến tay khách hàng đảm bảo tính bảo mật thông tin khi được cán bộ nhân viên của bên A yêu cầu.</li>
            <li style={{ marginBottom: 4 }}>Hỗ trợ cán bộ nhân viên khai thác của bên A trong công tác mang tài liệu đến tay khách hàng và nhận chứng từ bồi thường khi có phát sinh từ các trường, đảm bảo tính bảo mật thông tin khi được cán bộ của bên A yêu cầu.</li>
          </ol>

          {/* Điều 2 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>Điều 2. Thù lao cho bên B và thuế TNCN- Công tác viên</p>
          <ol style={{ paddingLeft: 22, margin: "6px 0", textAlign: "justify" }}>
            <li style={{ marginBottom: 4 }}>Thù lao của Công tác viên được xác định bằng tổng thù lao đối với các công việc được thực hiện tại Điều 1 của Hợp đồng này.</li>
            <li style={{ marginBottom: 4 }}>
              Căn cứ chi trả thù lao:
              <div style={{ paddingLeft: 16, marginTop: 4 }}>
                <div style={{ marginBottom: 3 }}>2.1) Đối với các công việc tại Khoản 1 Điều 1 của Hợp đồng này: Bên A chi trả thù lao hàng tháng dựa trên kết quả thực hiện công việc được xác định bằng tỷ lệ % trên doanh thu thực thu phí bảo hiểm thu được từ khách hàng mà Cộng tác viên hỗ trợ cho cán bộ khai thác.</div>
                <div style={{ marginBottom: 3 }}>2.2) Đối với các công việc tại Khoản 2, 3, 4, 5 Điều 2 của Hợp đồng này: Bên A chi trả thù lao hàng tháng dựa trên bảng chi tiết xác nhận nghiệm thu kết quả công việc hoàn thành đã thực hiện theo đơn gia công việc được quy định tại Phụ lục 02 đính kèm Hợp đồng này.</div>
              </div>
            </li>
            <li style={{ marginBottom: 4 }}>Thuế thu nhập cá nhân: Trường hợp thu nhập Cộng tác viên được nhận từ hoạt động phát sinh của hợp đồng này lớn hơn 2.000.000 đồng/tháng thì Bên A sẽ khấu trừ thuế thu nhập cá nhân là 10% tổng thu nhập của Cộng tác viên khi chi trả thù lao và nộp vào Ngân sách nhà nước theo quy định.</li>
            <li style={{ marginBottom: 4 }}>Hình thức thanh toán: Công ty sẽ chuyển khoản trực tiếp vào Tài khoản của CTV theo số tài khoản đã ghi trong Hợp đồng này.</li>
          </ol>
        </div>

        {/* TRANG 2: Điều 3, Điều 4 và Khối chữ ký (CÓ DẤU GIÁP LAI) */}
        <div
          className="contract-page-section contract-page-break"
          style={{
            pageBreakBefore: "always",
            position: "relative",
            marginTop: 28,
            paddingTop: 20,
            borderTop: "1px dashed #cbd5e1",
          }}
        >
          {/* Dấu giáp lai mép phải trang 2 */}
          <GiapLaiSeal company={company} customStamp={sealImg} data={data} pageNumber={2} visible={isManagerStamped} />

          {/* Điều 3 */}
          <p style={{ fontWeight: "bold", marginTop: 4, marginBottom: 4 }}>Điều 3. Nghĩa vụ và trách nhiệm các bên</p>
          <div style={{ fontWeight: "bold", marginTop: 6, marginBottom: 2 }}>1. Nghĩa vụ và trách nhiệm bên A:</div>
          <ul style={{ paddingLeft: 22, margin: "4px 0", textAlign: "justify" }}>
            <li style={{ marginBottom: 3 }}>Bảo đảm thực hiện đầy đủ những điều đã cam kết trong hợp đồng này.</li>
            <li style={{ marginBottom: 3 }}>Thanh toán đầy đủ, đúng thời hạn các chế độ và quyền lợi cho Cộng tác viên theo hợp đồng dịch vụ này.</li>
            <li style={{ marginBottom: 3 }}>Hỗ trợ về tài chính trong các trường hợp cần thiết để Cộng tác viên triển khai phát triển thị trường và tìm kiếm khách hàng.</li>
            <li style={{ marginBottom: 3 }}>Cử cán bộ kinh doanh hỗ trợ Cộng tác viên trong công việc đồng thời có trách nhiệm theo dõi, xác nhận công việc mà Cộng tác viên đã thực hiện.</li>
            <li style={{ marginBottom: 3 }}>Tạm dừng thực hiện, hoặc chấm dứt hoạt động thuê ngoài với bên B trong trường hợp bên A phát hiện hoạt động thuê ngoài này có ảnh hưởng bất lợi đến quyền và lợi ích hợp pháp của bên mua bảo hiểm, người được bảo hiểm.</li>
          </ul>

          <div style={{ fontWeight: "bold", marginTop: 8, marginBottom: 2 }}>2. Nghĩa vụ và trách nhiệm bên B:</div>
          <ul style={{ paddingLeft: 22, margin: "4px 0", textAlign: "justify" }}>
            <li style={{ marginBottom: 3 }}>Hỗ trợ giới thiệu khách hàng khi có nhu cầu về các dịch vụ bảo hiểm của Bên A.</li>
            <li style={{ marginBottom: 3 }}>Có trách nhiệm bảo vệ tài sản, uy tín và thương hiệu của Bên A.</li>
            <li style={{ marginBottom: 3 }}>Đảm bảo bí mật thông tin khách hàng của bên A.</li>
            <li style={{ marginBottom: 3 }}>Có nghĩa vụ và trách nhiệm bồi thường, khắc phục thiệt hại cho bên A với giá trị tương đương giá trị thiệt hại của bên A do lỗi bên B không thể thực hiện hoặc không thực hiện đúng thỏa thuận của hợp đồng này.</li>
            <li style={{ marginBottom: 3 }}>Không được ký hợp đồng thầu phụ hoặc giao lại công việc đã được thỏa thuận hợp đồng này cho bên thứ ba.</li>
          </ul>

          {/* Điều 4 */}
          <p style={{ fontWeight: "bold", marginTop: 12, marginBottom: 4 }}>Điều 4. Điều khoản chung</p>
          <ol style={{ paddingLeft: 22, margin: "6px 0", textAlign: "justify" }}>
            <li style={{ marginBottom: 4 }}>
              {data.endDate && endDateStr !== "—" && endDateStr !== "___/___/______" ? (
                <>
                  Hợp đồng này có thời hạn kể từ ngày <b>{startDateStr !== "—" && startDateStr !== "___/___/______" ? startDateStr : "…………."}</b> đến ngày <b>{endDateStr}</b>
                </>
              ) : (
                <>
                  Loại hình hợp đồng: <b>Không xác định thời hạn</b>{startDateStr !== "—" && startDateStr !== "___/___/______" ? <> (có hiệu lực kể từ ngày <b>{startDateStr}</b>)</> : ""}
                </>
              )}
            </li>
            <li style={{ marginBottom: 4 }}>Trong trường hợp xảy ra tranh chấp, hai bên sẽ giải quyết trên cơ sở thương lượng. Nếu không đạt được thỏa thuận thì sẽ đưa ra cơ quan nhà nước có thẩm quyền để giải quyết theo pháp luật của nước Cộng hòa xã hội chủ nghĩa Việt Nam.</li>
            <li style={{ marginBottom: 4 }}>Hợp đồng này được làm thành hai (02) bản, mỗi bên giữ một (01) bản, có giá trị pháp lý như nhau và có hiệu lực từ ngày ký.</li>
            <li style={{ marginBottom: 4 }}>Hết thời hạn Hợp đồng nếu có nhu cầu, hai bên thỏa thuận để gia hạn hoặc ký lại hợp đồng mới.</li>
          </ol>

          {/* Chữ ký 2 bên */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 35, marginBottom: 35, pageBreakInside: "avoid" }}>
            {/* Bên A: Người sử dụng lao động */}
            <div style={{ textAlign: "center", width: "45%" }}>
              <div style={{ fontWeight: "bold", fontSize: 13 }}>BÊN A</div>
              <div style={{ fontStyle: "italic", fontSize: 12, marginBottom: 8 }}>(Ký, đóng dấu)</div>

              <div style={{ minHeight: 75, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                {data.managerSignature ? (
                  <div style={{ position: "relative", display: "inline-block" }}>
                    {/* Chữ ký Sếp */}
                    <img src={data.managerSignature} alt="Chữ ký Bên A" style={{ maxHeight: 65, maxWidth: 180, position: "relative", zIndex: 1 }} />
                    
                    {/* Con dấu mộc đỏ trùm 1/3 chữ ký về bên trái */}
                    {isManagerStamped && (
                      <img
                        src={sealImg}
                        alt="Con dấu mộc đỏ công ty"
                        style={{
                          position: "absolute",
                          left: -40,
                          top: -24,
                          width: 105,
                          height: 105,
                          zIndex: 2,
                          opacity: 0.92,
                          transform: "rotate(-8deg)",
                          pointerEvents: "none",
                        }}
                      />
                    )}

                    <div style={{ fontSize: 11, color: "#dc2626", fontWeight: "bold", marginTop: 2, position: "relative", zIndex: 3 }}>
                      ★ Đã ký duyệt & đóng dấu số
                    </div>
                    {data.managerSignedAt && (
                      <div style={{ fontSize: 10, color: "#64748b", position: "relative", zIndex: 3 }}>
                        {new Date(data.managerSignedAt).toLocaleString("vi-VN")}
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ height: 60 }} />
                )}
              </div>

              <div style={{ fontWeight: "bold", marginTop: 6 }}>{company?.representative || "Phạm Thị Thu Lan"}</div>
            </div>

            {/* Bên B: Cộng tác viên */}
            <div style={{ textAlign: "center", width: "45%" }}>
              <div style={{ fontWeight: "bold", fontSize: 13 }}>BÊN B</div>
              <div style={{ fontStyle: "italic", fontSize: 12, marginBottom: 8 }}>(Ký và ghi rõ họ tên)</div>

              <div style={{ minHeight: 75, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                {data.employeeSignature ? (
                  <div>
                    <img src={data.employeeSignature} alt="Chữ ký Bên B" style={{ maxHeight: 65, maxWidth: 180 }} />
                    <div style={{ fontSize: 11, color: "#16a34a", fontWeight: "bold", marginTop: 2 }}>
                      ✓ Đã ký điện tử & xác thực OTP
                    </div>
                    {data.employeeSignedAt && (
                      <div style={{ fontSize: 10, color: "#64748b" }}>
                        {new Date(data.employeeSignedAt).toLocaleString("vi-VN")}
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ height: 60 }} />
                )}
              </div>

              <div style={{ fontWeight: "bold", marginTop: 6 }}>{data.employeeName || "___________________________"}</div>
            </div>
          </div>
        </div>

        {/* TRANG 3: PHỤ LỤC 01 (CÓ DẤU GIÁP LAI) */}
        <div
          className="contract-page-section contract-page-break"
          style={{
            pageBreakBefore: "always",
            position: "relative",
            paddingTop: 24,
            marginTop: 30,
            borderTop: "1px dashed #cbd5e1",
          }}
        >
          {/* Dấu giáp lai mép phải trang 3 */}
          <GiapLaiSeal company={company} customStamp={sealImg} data={data} pageNumber={3} visible={isManagerStamped} />

          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 15, textTransform: "uppercase" }}>PHỤ LỤC 01</div>
          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 13, marginBottom: 14, textTransform: "uppercase", lineHeight: 1.4 }}>
            TỶ LỆ THÙ LAO DỊCH VỤ CỘNG TÁC VIÊN THEO DOANH THU THỰC THU CÁC HỢP ĐỒNG BẢO HIỂM KHÔNG CÓ SỰ THAM GIA ĐẠI LÝ VÀ MÔI GIỚI BẢO HIỂM
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, marginBottom: 20 }}>
            <thead>
              <tr style={{ background: "#f8fafc" }}>
                <th style={{ border: "1px solid #111", padding: "8px 10px", textAlign: "left", fontWeight: "bold" }}>NGHIỆP VỤ</th>
                <th style={{ border: "1px solid #111", padding: "8px 10px", textAlign: "center", width: "42%", fontWeight: "bold" }}>TỶ LỆ/DOANH THU THỰC THU (CHƯA VAT)</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ fontWeight: "bold", background: "#f1f5f9" }}>
                <td colSpan={2} style={{ border: "1px solid #111", padding: "6px 10px" }}>I. BẢO HIỂM TỰ NGUYỆN</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm tài sản và Bảo hiểm thiệt hại</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>4%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm học sinh</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>15%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm tai nạn con người và sức khỏe</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>7%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm vật chất xe cơ giới</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>7%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm xe cơ giới (trừ bảo hiểm trách nhiệm dân sự của chủ xe cơ giới)</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>5%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm cháy, nổ tự nguyện</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>7%</td>
              </tr>
              <tr style={{ fontWeight: "bold", background: "#f1f5f9" }}>
                <td colSpan={2} style={{ border: "1px solid #111", padding: "6px 10px" }}>II. BẢO HIỂM BẮT BUỘC</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm trách nhiệm dân sự của chủ xe ô tô</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>4%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm trách nhiệm dân sự của chủ mô tô, xe máy</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>15%</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 10px" }}>Bảo hiểm cháy, nổ</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "center" }}>4%</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* TRANG 4: PHỤ LỤC 02 (CÓ DẤU GIÁP LAI) */}
        <div
          className="contract-page-section contract-page-break"
          style={{
            pageBreakBefore: "always",
            position: "relative",
            paddingTop: 24,
            marginTop: 30,
            borderTop: "1px dashed #cbd5e1",
          }}
        >
          {/* Dấu giáp lai mép phải trang 4 */}
          <GiapLaiSeal company={company} customStamp={sealImg} data={data} pageNumber={4} visible={isManagerStamped} />

          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 15, textTransform: "uppercase" }}>PHỤ LỤC 02</div>
          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 13, marginBottom: 14, textTransform: "uppercase" }}>
            ĐƠN GIÁ THÙ LAO CÔNG VIỆC CỦA CỘNG TÁC VIÊN
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f8fafc" }}>
                <th style={{ border: "1px solid #111", padding: "8px", width: "45px", textAlign: "center", fontWeight: "bold" }}>TT</th>
                <th style={{ border: "1px solid #111", padding: "8px 10px", textAlign: "left", fontWeight: "bold" }}>Nội dung</th>
                <th style={{ border: "1px solid #111", padding: "8px", width: "65px", textAlign: "center", fontWeight: "bold" }}>ĐVT</th>
                <th style={{ border: "1px solid #111", padding: "8px 10px", width: "120px", textAlign: "right", fontWeight: "bold" }}>Đơn giá (VNĐ)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>1</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "justify" }}>Hỗ trợ cán bộ nhân viên khai thác của bên A trong công tác mang tài liệu đến tay khách hàng và nhận chứng từ bồi thường khi có phát sinh từ các trường (nếu có), đảm bảo tính bảo mật thông tin khi được cán bộ của bên A yêu cầu. (trên 10km)</td>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>Lần</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "right", fontWeight: "bold" }}>100,000</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>2</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "justify" }}>Hỗ trợ cán bộ nhân viên khai thác của bên A trong công tác mang tài liệu đến tay khách hàng và nhận chứng từ bồi thường khi có phát sinh từ các trường (nếu có), đảm bảo tính bảo mật thông tin khi được cán bộ của bên A yêu cầu. (dưới 10km)</td>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>Lần</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "right", fontWeight: "bold" }}>50,000</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>3</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "justify" }}>Nhập liệu, in ấn tài liệu, liên quan đến hồ sơ khách hàng, sắp xếp, chuẩn bị hồ sơ tài liệu, công việc văn phòng khác khi được cán bộ nhân viên khai thác của bên A yêu cầu.</td>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>Ngày</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "right", fontWeight: "bold" }}>400,000</td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>4</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "justify" }}>Hỗ trợ cán bộ nhân viên khai thác của bên A phát tờ rơi quảng cáo, gửi Thư ngỏ, Bảng chào phí, Hợp đồng đến các Trường, khách hàng của bên A tại các địa điểm xác định khi được cán bộ nhân viên của bên A yêu cầu.</td>
                <td style={{ border: "1px solid #111", padding: "6px 8px", textAlign: "center" }}>Giờ</td>
                <td style={{ border: "1px solid #111", padding: "6px 10px", textAlign: "right", fontWeight: "bold" }}>100,000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* 2. KHỐI BIÊN BẢN CHỨNG NHẬN GIAO KẾT ĐIỆN TỬ (TRANG 5 - CÓ DẤU GIÁP LAI) */}
      {(data.employeeSignature || data.employee_signature || data.managerSignature || data.manager_signature || data.status === "completed" || data.status === "active") && (
        <div id="contract-audit-doc" className="contract-audit-doc" style={{ background: "#fff" }}>
          <AuditTrailPage data={data} company={company} showGiapLai={isManagerStamped} customStamp={sealImg} />
        </div>
      )}
    </div>
  );
}

export default React.memo(CollaboratorContractPreview);
